import { Loading } from "@/components/loading/Loading.tsx";
import { PaymentResponseTakesTimeNotice } from "@/modules/billing/payment_forms/components.tsx";
import { Trans } from "@lingui/react/macro";
import { useState } from "react";

export interface QrCode {
    qrcode_url: string;
}

export function QrCodeDisplay({ qrCode }: { qrCode: QrCode }) {
    const [qrCodeIsLoading, setQrCodeIsLoading] = useState(true);

    return (
        <div className="VStack items-center gap-2">
            <p className="font-size-subtitle">
                <Trans>Scan the QR code to pay</Trans>
            </p>
            {qrCodeIsLoading && <Loading />}
            <img
                className="w-full max-w-300px"
                style={{
                    // NB: Background color must be white even in dark mode
                    backgroundColor: "white",
                    display: qrCodeIsLoading ? "none" : "block",
                }}
                src={qrCode.qrcode_url}
                alt="QR code"
                fetchPriority="high"
                onLoad={() => setQrCodeIsLoading(false)}
                onError={() => setQrCodeIsLoading(false)}
            />
            <PaymentResponseTakesTimeNotice
                additionalMessage={<Trans>You may close this dialog after you have made a payment.</Trans>}
            />
        </div>
    );
}
